import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import { QuestionCircleOutlined } from '@ant-design/icons';

type ConfirmChangeStatusType = {
  isOpen: boolean;
  onCancel: () => void;
  changeBlockStatusUser: () => void;
};

const ConfirmChangeStatus = ({isOpen, onCancel, changeBlockStatusUser}: ConfirmChangeStatusType) => {
  const { t } = useTranslation();
  
  const { selectedUser } = useAppSelector((state) => state.dataUsers);  
  
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onCancel={onCancel}
      submit={changeBlockStatusUser}
      isLoading={false}
      title={selectedUser?.is_blocked ? t('Users.confirm.unblockUserTitle') : t('Users.confirm.blockUserTitle')}
      text={<span>
        <QuestionCircleOutlined style={{ color: 'red', paddingRight: 8 }} />
        {selectedUser?.is_blocked
          ? <span>{`${t('Users.confirm.confirmUserUnblock')}
            ${selectedUser?.first_name} ${selectedUser?.last_name} (${selectedUser?.email})?
          `}</span>
          : <span>{`${t('Users.confirm.confirmUserBlock')}
            ${selectedUser?.first_name} ${selectedUser?.last_name} (${selectedUser?.email})?
          ${t('Users.confirm.willLoseAccess')}`}</span>
        }
      </span>}
      okText={t('Users.confirm.yes')}
      cancelText={t('Users.confirm.cancel')}
      centered={true}
    />
  );
}

export default ConfirmChangeStatus;
